import { Component, h, render } from "preact";
import {
  INJECT_ELEMENT_CLASS,
  INJECT_WRAPPER_ELEMENT,
  PRODUCT_ELEMENT,
  PRODUCT_UID_ATTR,
} from "@/constants/selectors";

import $ from "jquery";
import Minilog from "minilog";
import ReviewForm from "@/components/ReviewForm/ReviewForm";
import ReviewsList from "@/components/ReviewsList/ReviewsList";
import Stars from "@/components/ProductRating/ProductRating";
import { awaitAjaxStopPromise } from "@/utils/awaitAjaxStop";
import { boundActions } from "@/store/actions";
import { getProducts } from "@/api";
import { injectRatingsInProuctCard } from "@/utils/injectRatingsInProductCards";
import { loadRatings } from "@/utils/loadRatings";
import { scrollToReviews } from "@/utils/scrollToReviews";

// eslint-disable-next-line new-cap
const logger = Minilog("ProductPage");
Minilog.enable();

export async function initProductPage() {
  logger.info("initProductPage start");

  // TODO: Поменять это решение, на отслеживание изменений DOM дерева
  await awaitAjaxStopPromise;

  // 1. Функция получает массив блоков своего типа

  const blocksJqElements = $(".t-store__prod-snippet__container");

  const productsJqElements = blocksJqElements.find(PRODUCT_ELEMENT);

  // 2. Отправка запроса на получение данных и запись их в стейт

  loadRatings(productsJqElements, logger);

  // 3. Встраивание компонентов плагина

  blocksJqElements.each((_, blockElement) => {
    const blockJqElement = $(blockElement);

    // Работа с перерисовкой модалки
    blockJqElement.find(`.${INJECT_ELEMENT_CLASS}`).remove();

    injectRatingsInProuctCard(blockJqElement.find(PRODUCT_ELEMENT), logger);

    injectInModal(blockJqElement, logger);
  });
}

/**
 * @param {*} modalJqElement
 * @param {*} logger
 */
function injectInModal(modalJqElement, logger) {
  const productUid = $(modalJqElement)
    .find('meta[itemprop="productID"]')
    .attr("content");

  if (!productUid) return;

  getProducts([productUid])
    .then((productsData) => {
      const loadedProductsData = productsData.reduce((acc, val) => {
        return {
          ...acc,
          [val.uid]: {
            ...val,
            ...{
              image: modalJqElement
                .find(".js-product-img")
                .first()
                .attr("data-original"),
              name: modalJqElement.find(".js-product-name").first().text(),
              price: Number.parseFloat(
                modalJqElement
                  .find(".js-store-prod-price-val")
                  .first()
                  .text()
                  .replaceAll(" ", "")
                  .replaceAll(".", "")
                  .replaceAll(",", "")
                  .trim()
              ),
            },
          },
        };
      }, {});

      boundActions.setProducts(loadedProductsData);

      logger.info("loadRatings finish");
    })
    .catch((err) => {
      logger.error("loadRatings error", err);
    });

  logger.info("injectInModal starts", { productUid, modalJqElement });

  const reviewsListElement = $(INJECT_WRAPPER_ELEMENT);
  render(
    <div className="t-container">
      <ReviewsList productUid={productUid} />
    </div>,
    reviewsListElement.get(0)
  );

  const reviewFormElement = $(INJECT_WRAPPER_ELEMENT);
  render(
    <div className="t-container">
      <ReviewForm productUid={productUid} />
    </div>,
    reviewFormElement.get(0)
  );

  const starsMiniElModalElement = $(INJECT_WRAPPER_ELEMENT);
  render(
    <Stars
      productUid={productUid}
      onClick={() => scrollToReviews(productUid)}
    />,
    starsMiniElModalElement.get(0)
  );

  modalJqElement.append([reviewsListElement, reviewFormElement]);

  modalJqElement
    .find(".t-store__prod-popup__name")
    .before(starsMiniElModalElement);

  logger.info("injectInModal finish");
}
